var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "events-page-wrap clearfix"
  }, [_c('vue-title', {
    attrs: {
      "title": "Profile - Your Indoor Cycling Solution"
    }
  }), _c('section', {
    staticClass: "login-wrap"
  }, [_vm.getProfile ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-3"
  }, [_c('avatar'), _c('div', {
    staticClass: "nav flex-column nav-pills",
    attrs: {
      "id": "v-pills-tab",
      "aria-orientation": "vertical",
      "role": "tablist"
    }
  }, [_vm._m(0), _c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "v-pills-connection-tab",
      "aria-controls": "v-pills-connection",
      "aria-selected": "false",
      "data-toggle": "pill",
      "href": "#v-pills-connection",
      "role": "tab"
    },
    on: {
      "click": _vm.connections
    }
  }, [_c('span', [_vm._v("Connections")]), _c('i', {
    staticClass: "fas fa-link"
  })]), _vm._m(1), _vm._m(2), _vm._m(3), _c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('span', [_vm._v("Logout")]), _c('i', {
    staticClass: "fas fa-sign-out-alt"
  })])])], 1), _c('section', {
    staticClass: "col-md-9",
    staticStyle: {
      "background-color": "#f4f4f4"
    }
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "v-pills-tabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade show active",
    attrs: {
      "id": "v-pills-profile",
      "aria-labelledby": "v-pills-profile-tab",
      "role": "tabpanel"
    }
  }, [_c('h3', [_vm._v("EDIT PROFILE")]), _vm.formErrors.length > 0 ? _c('ul', {
    staticClass: "indicator"
  }, _vm._l(_vm.formErrors, function (error, e) {
    return _c('li', {
      key: e,
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  }), 0) : _vm._e(), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.updateHandler.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l(_vm.schema, function (field, i) {
    return _c('div', {
      key: i,
      class: field.colClass
    }, [_c('div', {
      staticClass: "form-group"
    }, [field.type !== 'consent' ? _c('label', {
      domProps: {
        "textContent": _vm._s(field.label)
      }
    }) : _vm._e(), field.type === 'select' ? [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": field.readonly
      },
      on: {
        "change": function ($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
            return o.selected;
          }).map(function (o) {
            var val = "_value" in o ? o._value : o.value;
            return val;
          });
          _vm.$set(_vm.form, field.model, $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
        }
      }
    }, _vm._l(_vm.dropdowns[field.options], function (dd, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": dd.Id
        }
      }, [_vm._v(" " + _vm._s(dd.Name) + " ")]);
    }), 0)] : field.type === 'date' ? [field.type === 'checkbox' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "max": _vm.giveMaxRangeForDate(),
        "disabled": field.model === 'dob' && _vm.isKidUser,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[field.model]) ? _vm._i(_vm.form[field.model], null) > -1 : _vm.form[field.model]
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.form[field.model],
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, field.model, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, field.model, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, field.model, $$c);
          }
        }
      }
    }) : field.type === 'radio' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "max": _vm.giveMaxRangeForDate(),
        "disabled": field.model === 'dob' && _vm.isKidUser,
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.form[field.model], null)
      },
      on: {
        "change": function ($event) {
          return _vm.$set(_vm.form, field.model, null);
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "autocomplete": "chrome-off",
        "max": _vm.giveMaxRangeForDate(),
        "disabled": field.model === 'dob' && _vm.isKidUser,
        "type": field.type
      },
      domProps: {
        "value": _vm.form[field.model]
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.model, $event.target.value);
        }
      }
    })] : field.type === 'consent' ? [_c('div', {
      staticClass: "form-check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-check-input",
      attrs: {
        "required": field.validation.required,
        "type": "checkbox",
        "id": field.id
      },
      domProps: {
        "checked": Array.isArray(_vm.form[field.model]) ? _vm._i(_vm.form[field.model], null) > -1 : _vm.form[field.model]
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.form[field.model],
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, field.model, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, field.model, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, field.model, $$c);
          }
        }
      }
    }), _c('label', {
      staticClass: "form-check-label",
      attrs: {
        "for": field.id
      },
      domProps: {
        "innerHTML": _vm._s(field.consent_text)
      }
    })])] : [field.type === 'checkbox' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "disabled": field.readonly,
        "autocomplete": "chrome-off",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.form[field.model]) ? _vm._i(_vm.form[field.model], null) > -1 : _vm.form[field.model]
      },
      on: {
        "change": function ($event) {
          var $$a = _vm.form[field.model],
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, field.model, $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, field.model, $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, field.model, $$c);
          }
        }
      }
    }) : field.type === 'radio' ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "disabled": field.readonly,
        "autocomplete": "chrome-off",
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.form[field.model], null)
      },
      on: {
        "change": function ($event) {
          return _vm.$set(_vm.form, field.model, null);
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.model],
        expression: "form[field.model]"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": field.label,
        "disabled": field.readonly,
        "autocomplete": "chrome-off",
        "type": field.type
      },
      domProps: {
        "value": _vm.form[field.model]
      },
      on: {
        "input": function ($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.model, $event.target.value);
        }
      }
    })], _vm.submitted && _vm.getError(field.model) ? _c('div', {
      staticClass: "text-danger"
    }, [_vm._v(" " + _vm._s(field.label) + " is required. ")]) : _vm._e()], 2)]);
  }), _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.weightError))])], 2), _c('button', {
    staticClass: "btn-universal",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _c('a', {
    staticClass: "btn-universal btn-register-cancel",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "href": _vm.makePageLink('events')
    }
  }, [_vm._v("Cancel")])])]), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "v-pills-connection",
      "aria-labelledby": "v-pills-connection-tab",
      "role": "tabpanel"
    }
  }, [_vm.socialLinks ? _c('social', {
    attrs: {
      "linkedNetworks": _vm.socialLinks,
      "userNetworksData": _vm.userNetworksData,
      "isNormalUser": _vm.isNormalUser
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "v-pills-password",
      "aria-labelledby": "v-pills-password-tab",
      "role": "tabpanel"
    }
  }, [_c('password')], 1), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "v-pills-activity",
      "aria-labelledby": "v-pills-activity-tab",
      "role": "tabpanel"
    }
  }, [_c('activities', {
    attrs: {
      "files": _vm.getFiles
    }
  })], 1), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "v-pills-delete-account",
      "aria-labelledby": "v-pills-delete-account",
      "role": "tabpanel"
    }
  }, [_c('deleteAccount', {
    attrs: {
      "email": _vm.form.email,
      "isKidUser": _vm.isKidUser,
      "parentEmail": _vm.getProfile.parentEmail
    }
  })], 1)])])])])]) : _vm._e()])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "nav-link active",
    attrs: {
      "id": "v-pills-profile-tab",
      "aria-controls": "v-pills-profile",
      "aria-selected": "true",
      "data-toggle": "pill",
      "href": "#v-pills-profile",
      "role": "tab"
    }
  }, [_c('span', [_vm._v("Edit Profile")]), _c('i', {
    staticClass: "fas fa-user"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "nav-link",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "v-pills-activity-tab",
      "aria-controls": "v-pills-activity",
      "aria-selected": "true",
      "data-toggle": "pill",
      "href": "#v-pills-activity",
      "role": "tab"
    }
  }, [_c('span', [_vm._v("Activity Files")]), _c('i', {
    staticClass: "fas fa-user"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "v-pills-password-tab",
      "aria-controls": "v-pills-profile",
      "aria-selected": "true",
      "data-toggle": "pill",
      "href": "#v-pills-password",
      "role": "tab"
    }
  }, [_c('span', [_vm._v("Change Password")]), _c('i', {
    staticClass: "fas fa-user"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "nav-link text-danger",
    attrs: {
      "id": "v-pills-delete-account-tab",
      "aria-controls": "v-pills-profile",
      "aria-selected": "true",
      "data-toggle": "pill",
      "href": "#v-pills-delete-account",
      "role": "tab"
    }
  }, [_c('span', [_vm._v("Delete Account")]), _c('i', {
    staticClass: "fas fa-user"
  })]);
}]

export { render, staticRenderFns }